import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const brandDrawerInitialValues = {
  brandRepeater: [
    {
      code: '',
      title: '',
    },
  ],
  code: '',
  title: '',
};

export const getBrandSections = (
  values = brandDrawerInitialValues,
  isEdit = false
): IDynamicFormWidgetSection[] => {
  if (isEdit) {
    return [
      {
        sectionTitle: '',
        inputs: {
          code: {
            name: 'code',
            title: 'Code',
            type: FormFieldType.splitPrefix,
            prefixValue: 'Brand',
            placeholder: 'Code',
            value: values.code ?? '',
            required: true,
            customValidator: (vals) => {
              if (!vals.code) return 'Required';
              if (!/^\d+$/.test(vals.code)) return 'Only numbers allowed';
              return null;
            },
          },
          title: {
            name: 'title',
            title: 'Title',
            type: FormFieldType.text,
            placeholder: 'Title',
            value: values.title ?? '',
            required: true,
          },
        },
      },
    ];
  }

  return [
    {
      sectionTitle: 'Brand Info',
      inputs: {
        brandRepeater: {
          name: 'brandRepeater',
          title: '',
          type: FormFieldType.repeaterBox,
          minRepeaterLength: 1,
          maxRepeaterLength: 999,
          addButtonText: '+Add Brand',
          value: values.brandRepeater,
          inputs: {
            code: {
              name: 'code',
              title: 'Code',
              type: FormFieldType.splitPrefix,
              prefixValue: 'Brand',
              placeholder: 'Code',
              required: true,
              // customValidator: (vals) => {
              //   for (let i = 0; i < vals.brandRepeater.length; i++) {
              //     const code = vals.brandRepeater[i]?.code;
              //     if (!code) return `Required`;
              //     if (!/^\d+$/.test(code)) return `Only numbers allowed`;
              //   }

              //   return null;
              // },
            },
            title: {
              name: 'title',
              title: 'Title',
              type: FormFieldType.text,
              placeholder: 'Title',
              required: true,
            },
          },
        },
      },
    },
  ];
};
